const IMAGE_MODE_SEARCH_PARAM_NAME = 'image_mode';
const ORIGINAL_IMAGE_MODE_SEARCH_PARAM_VALUE = 'original';

export function get_should_use_original_image_mode() {
  if (typeof window === 'undefined') {
    return false;
  }

  return get_should_use_original_image_mode_from_search(window.location.search);
}

export function get_should_use_original_image_mode_from_search(
  search_query: string,
) {
  const search_params = new URLSearchParams(search_query);

  return (
    search_params.get(IMAGE_MODE_SEARCH_PARAM_NAME) ===
    ORIGINAL_IMAGE_MODE_SEARCH_PARAM_VALUE
  );
}
